import { UPDATE_STATE_PARAMS, RESET_STATE, INITIALIZE_MOLECULAR_DATA } from './MolecularModalConstants';

export const initialState = {
  formulaText: '',
  molecularData: {},
  updateStringTypeDataValue: null,
};

// eslint-disable-next-line default-param-last
export default function molecularModalReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_STATE_PARAMS:
      return {
        ...state,
        ...action.params,
      };
    case RESET_STATE:
      return {
        ...state,
        ...initialState,
      };
    case INITIALIZE_MOLECULAR_DATA: {
      return {
        ...state,
        molecularData: action.data,
      };
    }
    default: {
      return state;
    }
  }
}
